import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { RootState } from '../../redux/root';
import { dispatch } from '../../redux/store';
import { setTableCheckAllClicked, setTableSelectedRows } from '../../redux/slices/generalSlice';

const TableLightCellCheckbox = ({ item, index }) => {
  const { tableSelectAll, tableSelectedRows, tableCheckAllClicked } = useSelector((s: RootState) => s.general);
  const [checked, setChecked] = useState<boolean>(false);
  useEffect(() => {
    if (tableSelectedRows.length > 0) {
      const _item = tableSelectedRows.find(i => i.id === item.id);
      if (_item) {
        setChecked(_item.selected);
      }
    }
  }, [tableSelectedRows]);

  useEffect(() => {
    const _tableSelectedRows = tableSelectedRows.map(row => {
      return { id: row.id, selected: tableSelectAll };
    });
    if (tableCheckAllClicked) {
      dispatch(setTableSelectedRows(_tableSelectedRows));
    }
  }, [tableSelectAll]);
  const onChange = e => {
    const _tableSelectedRows = tableSelectedRows.map(row => {
      if (item.id === row.id) {
        const _checked = e.target.checked;
        return { id: row.id, selected: _checked };
      }
      return row;
    });
    dispatch(setTableSelectedRows(_tableSelectedRows));
    dispatch(setTableCheckAllClicked(false));
  };
  return <Checkbox key={index}>{tableSelectedRows.length > 0 && <input type="checkbox" onChange={onChange} checked={checked} />}</Checkbox>;
};

export default TableLightCellCheckbox;

const Checkbox = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px;

  input {
    cursor: pointer;
    accent-color: var(--primary-600);
    width: 16px;
    height: 16px;
  }
`;
